import LoginComponent from "../components/Login";

export default function Login() {
    return ( 
        <div className="form-display">
            <LoginComponent />    
        </div> 
    );
  }